import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AnnotationHeart = function AnnotationHeart(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a2.9997 2.9997 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.7c0 1.3978 0 2.0967-.2284 2.6481a2.9997 2.9997 0 0 1-1.6235 1.6235C18.5967 18 17.8978 18 16.5 18c-.4886 0-.7329 0-.9595.0535a2.0002 2.0002 0 0 0-.822.411c-.1788.1492-.3254.3446-.6185.7355l-1.46 1.9467c-.2171.2895-.3257.4342-.4588.486a.5002.5002 0 0 1-.3624 0c-.1331-.0518-.2417-.1965-.4588-.486L9.9 19.2c-.2932-.3909-.4397-.5863-.6185-.7355a2.0002 2.0002 0 0 0-.822-.411C8.233 18 7.9885 18 7.5 18c-1.3978 0-2.0967 0-2.648-.2284a2.9999 2.9999 0 0 1-1.6236-1.6235C3 15.5967 3 14.8978 3 13.5V7.8Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      fillRule: "evenodd",
      d: "M11.9973 8.3306c-.7998-.909-2.1334-1.1535-3.1354-.3212-1.002.8324-1.1431 2.2241-.3562 3.2085.468.5854 1.614 1.6352 2.4662 2.39.3518.3116.5277.4674.7395.5306.1811.0541.3906.0541.5718 0 .2117-.0632.3876-.219.7394-.5306.8522-.7548 1.9983-1.8046 2.4662-2.39.7869-.9844.6631-2.3848-.3562-3.2085-1.0192-.8236-2.3356-.5878-3.1353.3212Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a2.9997 2.9997 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v5.7c0 1.3978 0 2.0967-.2284 2.6481a2.9997 2.9997 0 0 1-1.6235 1.6235C18.5967 18 17.8978 18 16.5 18c-.4886 0-.7329 0-.9595.0535a2.0002 2.0002 0 0 0-.822.411c-.1788.1492-.3254.3446-.6185.7355l-1.46 1.9467c-.2171.2895-.3257.4342-.4588.486a.5002.5002 0 0 1-.3624 0c-.1331-.0518-.2417-.1965-.4588-.486L9.9 19.2c-.2932-.3909-.4397-.5863-.6185-.7355a2.0002 2.0002 0 0 0-.822-.411C8.233 18 7.9885 18 7.5 18c-1.3978 0-2.0967 0-2.648-.2284a2.9999 2.9999 0 0 1-1.6236-1.6235C3 15.5967 3 14.8978 3 13.5V7.8Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.9973 8.3306c-.7998-.909-2.1334-1.1535-3.1354-.3212-1.002.8324-1.1431 2.2241-.3562 3.2085.468.5854 1.614 1.6352 2.4662 2.39.3518.3116.5277.4674.7395.5306.1811.0541.3906.0541.5718 0 .2117-.0632.3876-.219.7394-.5306.8522-.7548 1.9983-1.8046 2.4662-2.39.7869-.9844.6631-2.3848-.3562-3.2085-1.0192-.8236-2.3356-.5878-3.1353.3212Z",
      clipRule: "evenodd"
    })]
  }));
};
export default AnnotationHeart;